import { useLanguage } from "@/i18n/LanguageContext";

export default function AreasNotServedSection() {
  const { t } = useLanguage();
  const areas = [
    {
      titleKey: "serviceAreas.notServed1Title",
      bodyKey: "serviceAreas.notServed1Body",
    },
    {
      titleKey: "serviceAreas.notServed2Title",
      bodyKey: "serviceAreas.notServed2Body",
    },
  ];

  return (
    <section className="bg-[#fefce8] py-12 md:py-[60px]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-secondary mb-3">
            {t("serviceAreas.notServedH2")}
          </h2>
          <p className="text-base text-[#374151] max-w-[720px] mx-auto leading-relaxed">
            {t("serviceAreas.notServedSub")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {areas.map((area, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl p-6 shadow-sm"
            >
              <h3 className="text-lg font-bold text-secondary mb-2">
                {t(area.titleKey)}
              </h3>
              <p className="text-sm text-[#374151] leading-relaxed">
                {t(area.bodyKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}